// extracted by mini-css-extract-plugin
export default {"footer":"footer-module--footer--3L5Rb","copyright":"footer-module--copyright--3WaIr","text":"footer-module--text--1iI4D"};